import { render, staticRenderFns } from "./th.vue?vue&type=template&id=33e682ea"
import script from "./th.vue?vue&type=script&lang=js"
export * from "./th.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports